import { render, staticRenderFns } from "./searchBtn.vue?vue&type=template&id=71700ad5"
import script from "./searchBtn.vue?vue&type=script&lang=js"
export * from "./searchBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports